import {
  LoadSalesforceLiveChat,
  useIsSalesforceLiveChatAvailable,
  SalesforceChatConfig,
} from '@reapit-sales/live-support-chat'
import { useUserConfigurationsContext } from '@reapit-sales/api-v2'
import { useCurrentUser, useCurrentOffice } from './utility'
import { featureToggle } from '../feature-toggle'
import { liveChat } from '../feature-toggle/constants'

// Salesforce Chat Configurations
const SALESFORCE_LIVE_CHAT: SalesforceChatConfig = {
  orgId: process.env.LIVE_CHAT_ORG_ID || '',
  deploymentId: process.env.LIVE_CHAT_DEPLOYMENT_ID || '',
  communityUrl: process.env.LIVE_CHAT_COMMUNITY_URL || '',
  scrt2URL: process.env.LIVE_CHAT_SCRT2URL || '',
  bootstrapScriptUrl: process.env.LIVE_CHAT_BOOTSTRAP_SCRIPT_URL || '',
}

export const LoadLiveSupportChat = () => {
  const { settings } = useUserConfigurationsContext()
  // Get real user and office data from your application's context/hooks
  const currentUser = useCurrentUser()
  const currentOffice = useCurrentOffice()

  // Determine chat availability by passing in the actual data
  const isSalesforceLiveChatEnabled = useIsSalesforceLiveChatAvailable({
    currentUser,
    currentOffice,
  })

  // Select the desired CRM configuration
  const activeChatConfig = SALESFORCE_LIVE_CHAT

  return (
    settings &&
    featureToggle(liveChat, settings) &&
    process.env.LIVE_CHAT_BOOTSTRAP_SCRIPT_URL &&
    isSalesforceLiveChatEnabled &&
    activeChatConfig && <LoadSalesforceLiveChat config={activeChatConfig} user={currentUser} office={currentOffice} />
  )
}
